module.exports = __webpack_public_path__ + "static/media/aboutus.03aaebf1.jpg";